import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/styles/btn-styles.css';
import '../src/assets/styles/form-styles.css';
import '../src/assets/styles/table-styles.css';
import '../src/assets/styles/modal-styles.css';
import '../src/assets/styles/file-upload-styles.css';
import reportWebVitals from './reportWebVitals';
import UserLayout from './layouts/UserLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Login from './pages/Login/Login';
import PrivateRoute from './routes/PrivateRoute';
import RedirectRoute from './routes/RedirectRoute';
import { ToastContainer } from 'react-toastify';
import VerificationLayout from './layouts/VerificationLayout';
import ExamControllerLayout from './layouts/ExamControllerLayout';
import ExamControllerAssistantLayout from './layouts/ExamControllerAssistantLayout';
import NormalUserLayout from './layouts/NormalUserLayout';
import EntityAdminLayout from './layouts/EntityAdminLayout';
import CertificateIssuerLayout from './layouts/CertificateIssuerLayout';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/dashboard",
                  exam_controller: "/controller/dashboard",
                  auditor: "/auditor/dashboard",                 
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <Login />
              </RedirectRoute>
            }
          />
          <Route
            path="*"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/dashboard",
                  exam_controller: "/controller/dashboard",
                  auditor: "/auditor/dashboard",                 
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <Navigate to="/login" />
              </RedirectRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard",
                  auditor: "/auditor/dashboard",                 
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <UserLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/controller/*"
            element={
              <PrivateRoute
                allowedRoles={["exam_controller"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard",
                  auditor: "/auditor/dashboard",                 
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <ExamControllerLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/auditor/*"
            element={
              <PrivateRoute
                allowedRoles={["auditor"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard", 
                  auditor: "/auditor/dashboard",                 
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <ExamControllerAssistantLayout />
              </PrivateRoute>
            }
          />
          <Route
            path="/user/*"
            element={
              <PrivateRoute
                allowedRoles={["viewer"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard", 
                  auditor: "/auditor/dashboard",                  
                  user: "/user/dashboard",
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <NormalUserLayout />
              </PrivateRoute>
            }
          />
           <Route
            path="/entity_admin/*"
            element={
              <PrivateRoute
                allowedRoles={["entity_admin"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard", 
                  auditor: "/auditor/dashboard",                  
                  user: "/user/dashboard",           
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <EntityAdminLayout />
              </PrivateRoute>
            }
          />
            <Route
            path="/issuer/*"
            element={
              <PrivateRoute
                allowedRoles={["certificate_issuer"]}
                roleRedirects={{
                  admin: "/admin/dashboard",                  
                  exam_controller: "/controller/dashboard", 
                  auditor: "/auditor/dashboard",                  
                  user: "/user/dashboard",           
                  entity_admin: "/entity_admin/dashboard",
                  certificate_issuer: "/issuer/dashboard",
                }}
              >
                <CertificateIssuerLayout />
              </PrivateRoute>
            }
          />
          <Route
            path="/document_ref/:document_ref"
            element={
              <VerificationLayout />
            }
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
